import React, { useEffect, useState } from 'react';
import { ApiDocToken } from '@/types/ApiDocs.ts';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select.tsx';
import { Check, Copy, Key } from 'lucide-react';

interface TokenSelectorProps {
    tokens: ApiDocToken[];
    selected: string;
    onSelect: (t: string) => void;
}

export function TokenSelector({ tokens, selected, onSelect }: TokenSelectorProps) {
    const [copied, setCopied] = useState(false);

    // בחירה אוטומטית אם יש רק טוקן אחד
    useEffect(() => {
        if (tokens.length === 1 && !selected) {
            onSelect(tokens[0].token);
        }
    }, [tokens]);

    const handleCopy = () => {
        navigator.clipboard.writeText(selected);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div className="flex items-center gap-2 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2 text-sm">
            <Key className="size-4 text-amber-600 shrink-0" />
            <span className="text-amber-800 font-medium shrink-0">טוקן פעיל:</span>
            {tokens.length === 0 ? (
                <span className="text-gray-500 text-xs">לא נמצאו טוקנים למוסד זה</span>
            ) : (
                <Select value={selected} onValueChange={onSelect}>
                    <SelectTrigger className="h-7 text-xs border-amber-300 bg-white min-w-[220px]">
                        <SelectValue placeholder="בחר טוקן..." />
                    </SelectTrigger>
                    <SelectContent>
                        {tokens.map((t) => (
                            <SelectItem key={t.token} value={t.token}>
                                <span className="font-medium">{t.school_name}</span>
                                <span className="font-mono text-gray-500 mr-2 text-[11px]">
                                    — {t.token.slice(0, 12)}…
                                </span>
                            </SelectItem>
                        ))}
                    </SelectContent>
                </Select>
            )}
            {selected && (
                <button
                    onClick={handleCopy}
                    title="העתק טוקן"
                    className="flex items-center gap-1 h-7 px-2 rounded border border-amber-300 bg-white text-amber-700 hover:bg-amber-100 text-xs transition-colors shrink-0"
                >
                    {copied ? (
                        <>
                            <Check className="size-3 text-green-600" />
                            <span className="text-green-600">הועתק</span>
                        </>
                    ) : (
                        <>
                            <Copy className="size-3" />
                            <span>העתק</span>
                        </>
                    )}
                </button>
            )}
        </div>
    );
}
